// extracted by mini-css-extract-plugin
export default {"container":"Reader__container--KZoPRMaNzl","header":"Reader__header--TwH1s4CLrZ"};